import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from "react-redux";
import { EditOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { getUserSession, ripSession } from "../util-components/Session/Session";
import { useHistory } from "react-router-dom";
import AuthService from "services/AuthService";

const menuItem = [
  {
    title: "Edit Profile",
    icon: EditOutlined,
    path: "/",
  },
];

export const NavProfile = (props) => {
  const profileImg = "/img/avatars/thumb-1.jpg";
  const user = getUserSession();
  const history = useHistory();
  const truncate = (str, n) => {
    return str.length > n ? str.substr(0, n - 1) + "..." : str;
  };

  const logout = async () => {
    await AuthService.logOut();
    ripSession();
    history.push("/auth/login");
  };

  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <div className="pl-3">
            <h4 className="mb-0">{truncate(user ? user.name : "", 15)}</h4>
            <span className="text-muted">
              {user
                ? user.employee
                  ? user.employee.designation
                  : "not defined"
                : ""}
            </span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => (
            <Menu.Item key={i}>
              {/* <a href={el.path}> */}
              <Icon className="mr-3" type={el.icon} />
              <span className="font-weight-normal">{el.title}</span>
              {/* </a> */}
            </Menu.Item>
          ))}
          <Menu.Item key={menuItem.length + 1} onClick={logout}>
            <span>
              <LogoutOutlined className="mr-3" />
              <span className="font-weight-normal">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );

  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar
            style={{ backgroundColor: "#87d068" }}
            icon={<UserOutlined />}
          />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

export default connect(null, {})(NavProfile);
